import {
  ChangeDetectionStrategy,
  Component,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ChangeDetectorRef,
  inject,
} from '@angular/core';

@Component({
    selector: 'queue-countup',
    templateUrl: './queue-countup.component.html',
    styleUrls: ['./queue-countup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class QueueCountUpComponent implements OnInit, OnDestroy {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly zone = inject(NgZone);
  private timer: any;
  private _elapsedBusinessTime: number = 0;

  anticipatedTime: number = 0;
  showBlueIcon = false;

  private _clinicalReviewAdjudicationDate: number | null = null;
  private _nextNonBusinessDate: number;
  private _isBusinessDayNow: boolean = false;
  private _anticipatedManualDecisionDate: number | null = null;

  @Input() set elapsedBusinessTime(value: number | string) {
    this._elapsedBusinessTime = typeof value === 'string' ? parseInt(value, 10) : value;
  }

  @Input() set nextNonBusinessDate(value: string | Date) {
    this._nextNonBusinessDate = new Date(value).getTime();
  }

  @Input() set isBusinessDayNow(value: boolean | string) {
    this._isBusinessDayNow = typeof value === 'string' ? value === 'true' : value;
  }

  @Input() set anticipatedManualDecisionDate(value: string | Date) {
    this._anticipatedManualDecisionDate = value ? new Date(value).getTime() : null;
  }
 @Input() timeTakenForReviewAdjudication: number = 0;

  @Input() set clinicalReviewAdjudicationDate(value: string | null) {
    this._clinicalReviewAdjudicationDate = value ? new Date(value).getTime() : null;

    if (this._clinicalReviewAdjudicationDate) {
      this.showBlueIcon = false;
      this.clearTimer();
      this.anticipatedTime = this._elapsedBusinessTime;
      this.checkShowBlueIcon();
    }
  }

  ngOnInit() {
    if (!this._clinicalReviewAdjudicationDate) {
      this.adjustElapsedTime();
      this.startTimer();
    }
  }

  ngOnDestroy() {
    this.clearTimer();
  }

  private startTimer(): void {
    this.clearTimer();
    this.showBlueIcon = false;

    const stopTime = this._nextNonBusinessDate;
    const shouldRun = this._isBusinessDayNow && Date.now() < stopTime;

    this.anticipatedTime = this._elapsedBusinessTime;

    if (!shouldRun) {
      return; // Don't start the interval
    }

    this.zone.runOutsideAngular(() => {
      this.timer = setInterval(() => {
        const now = Date.now();
        const displayedState = this.getDisplayedState();

        this.checkShowBlueIcon();

        if (now >= stopTime) {
          this.clearTimer();
        } else {
          this.anticipatedTime += 1000;
        }

        if (this.getDisplayedState() !== displayedState) {
          this.cdr.detectChanges();
        }
      }, 1000);
    });
  }

  private getDisplayedState(): string {
    return `${!!this.anticipatedTime}|${Math.floor(this.anticipatedTime / 60000)}|${this.showBlueIcon}`;
  }

  private adjustElapsedTime(): void {
    const now = Date.now();

    const fetchedAtStr = sessionStorage.getItem('elapsedTimeFetchedAt');
    const fetchedAt = fetchedAtStr ? parseInt(fetchedAtStr, 10) : now;

    const shouldRun = this._isBusinessDayNow && now < this._nextNonBusinessDate;

    if (!shouldRun) {
      return;
    }

    const delta = now - fetchedAt;
    if (delta > 0) {
      this._elapsedBusinessTime += delta;
    }
  }

  private checkShowBlueIcon(): void {
    this.showBlueIcon = this._anticipatedManualDecisionDate
      ? Date.now() > this._anticipatedManualDecisionDate
      : false;
  }

  private clearTimer(): void {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
